import Echo from "laravel-echo"

import Pusher from "pusher-js"
window.Pusher = Pusher

const reverbAppKey = import.meta.env.VITE_REVERB_APP_KEY

if (reverbAppKey) {
    window.Echo = new Echo({
        broadcaster: "reverb",
        key: reverbAppKey,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT,
        wssPort: import.meta.env.VITE_REVERB_PORT,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? "https") === "https",
        enabledTransports: ["ws", "wss"],
    })
} else {
    // eslint-disable-next-line no-console
    console.warn("VITE_REVERB_APP_KEY is not set, realtime updates are disabled.")
}
